const CustomSelect = ({
  label,
  name,
  value,
  options,
  onChange,
  disabled = false,
  isDarkMode = false,
  isEditing = false,
}) => {
  return (
    <div className="flex flex-col gap-2">
      {label && (
        <label
          htmlFor={name}
          className={`text-sm font-medium ${
            isDarkMode ? "text-gray-200" : "text-gray-700"
          }`}
        >
          {label}
        </label>
      )}
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`w-full rounded-md border p-2 outline-none transition-all
  ${
    isDarkMode
      ? "bg-black text-white border-customRed"
      : "bg-white text-gray-900 border-gray-300 focus:border-customBlue"
  }
  ${!isEditing ? "opacity-60 cursor-not-allowed" : ""}
  ${
    disabled
      ? isDarkMode
        ? "bg-[#8a8a8a] border-0 text-gray-300"
        : "bg-gray-200 border-0 text-gray-600"
      : ""
  }
`}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value} disabled={opt.disabled}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomSelect;
